<template>
<div>
  <table class="table">
    <tr>
      <th>
        Imię i nazwisko
      </th>
      <th>
        Akcje
      </th>
    </tr>
    <tr v-for="item in items">
      <td>
        <a class="main-link" @click="$router.push({name: 'admin.users.show', params: {id: item.id}})">{{ item.first_name + ' ' + item.last_name }}</a>
      </td>

      <td class="actions">
        <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.users.edit', params: {id: item.id}})">Edytuj</ui-button>
        <ui-button type="flat" icon="highlight_off" color="danger" @click.prevent="remove(item)">Usuń</ui-button>
      </td>
    </tr>
  </table>
  <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>
</template>

<script>
import Users from './../../services/Users'
import EventEmitter from './../../services/EventEmitter'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  methods: {
    getService () {
      return Users
    },
    _remove (item) {
      Users.remove(item.id).then((res) => {
        if (res.status === 204) {
          this.reload()
          this.notify('Usunięto')
        }
      })
    },
    remove (item) {
      EventEmitter.$emit('confirm.show', {
        confirmCb: () => {
          this._remove(item)
        }
      })
    }
  },
  mounted () {
    EventEmitter.$on('users.reload', () => {
      this.meta.current_page = 1
      this.reload()
    })
  }
  // events: {
  //   'users.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }
}

</script>


// WEBPACK FOOTER //
// List.vue?988e08e6